<template>
  <main class="main common_apply_list" role="main" v-if="isCompleted">
    <div class="main_con" id="main_con">
      <div class="sub_main">
        <div class="h_tab">
          <ul>
            <li>
              <button @click="goLink('Apply.Main')">인터넷</button>
            </li>
            <li class="on"><button>휴대폰</button></li>
          </ul>
        </div>
        <div class="n_suggest">
          <div class="regi_application">
            <div class="round_filter mt30">
              <ul>
                <li @click="selectSort">
                  <button>{{ isSortText }}</button>
                </li>
              </ul>
            </div>
            <div class="regi_appli_list" v-if="list.length > 0">
              <ul>
                <li v-for="(item, index) in list" :key="index">
                  <div class="list_li">
                    <div class="left">
                      <div class="list_top_area">
                        <p class="date">{{ getCreateAt(item.createdAt) }}</p>
                        <div class="area">
                          <img
                            :src="
                              require(`@/assets/front/images/mobile/i_mytown_s_r.svg`)
                            "
                            alt=""
                          />
                          <div class="addr">
                            {{ storeAreaShort(item.store.storeArea) }}
                          </div>
                        </div>
                        <div
                          class="review_btn"
                          v-if="
                            item.store.myReviewCnt < 1 && !item.store.storeDel
                          "
                        >
                          <button @click="goToReviewWrite(item)">
                            <span>후기남기기</span>
                          </button>
                        </div>
                      </div>
                      <div class="profile">
                        <div
                          class="n_thumb"
                          @click="goShopDetail(item.storeId)"
                        >
                          <div class="n_thumb_inner">
                            <img
                              :src="item.store.storeProfile"
                              alt=""
                              v-if="item.store.storeProfile"
                            />
                            <img
                              :src="
                                setShopProfileImg(
                                  item.store.storeName,
                                  item.store.storeId,
                                )
                              "
                              alt=""
                              v-else
                            />
                            <img
                              v-if="item.store.cert === 1"
                              class="mark"
                              src="@/assets/front/images/new/icon_consent_s.png"
                            />
                          </div>
                        </div>
                        <div class="pro_txt">
                          <h1 class="name">{{ item.store.storeName }}</h1>
                          <div class="shop_index">
                            <div v-if="!item.store.storeDel">
                              <!-- <dl>
                              <dt>상담</dt>
                              <dd>{{ item.store.chatCnt }}건</dd>
                            </dl> -->
                              <dl>
                                <dt>휴대폰개통</dt>
                                <dd>{{ item.store.mobileSaleCnt }}건</dd>
                              </dl>
                              <dl @click.stop="goToReview(item)">
                                <dt>후기</dt>
                                <dd>
                                  {{ item.store.reviewCnt }}건(평가
                                  {{
                                    Number(item.store.evaluationScore).toFixed(
                                      1,
                                    )
                                  }}점)
                                </dd>
                              </dl>
                            </div>
                            <div class="none" v-else>
                              탈퇴한 매장입니다.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="center_btn">
                      <button
                        class="btn_list"
                        @click="goMobilePromise(item.id)"
                      >
                        <img
                          :src="
                            require('@/assets/front/images/internet_commerce/i_btn_list_b.svg')
                          "
                        />
                        <span>약속내역</span>
                      </button>
                      <button
                        @click="enterChatRoom(item.storeId)"
                        v-if="!item.store.storeDel"
                      >
                        <img
                          :src="
                            require('@/assets/front/images/internet_commerce/i_btn_chat_w.svg')
                          "
                        />
                        <span>상담하기</span>
                      </button>
                      <button v-else class="none">
                        <img
                          :src="
                            require('@/assets/front/images/internet_commerce/i_btn_chat_w.svg')
                          "
                        />
                        <span>상담하기</span>
                      </button>
                    </div>
                  </div>
                  <div class="list_con_1">
                    <div class="con_1">
                      <div class="txt_1">방문날짜</div>
                      <div class="txt_2">{{ item.visitDate }}</div>
                    </div>
                    <div class="con_2">
                      <div class="txt_1">방문예상시간</div>
                      <div class="txt_2">{{ item.visitHour }}</div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <!-- <div v-else>
              <div class="list_empty">
                <div class="empty_img">
                  <img
                    src="@/assets/front/images/internet_commerce/i_empty_n_2.svg"
                    alt=""
                  />
                </div>
                <div class="empty_txt_1">방문 약속 내역이 없습니다.</div>
              </div>
            </div> -->
            <div
              class="list_progress_none"
              v-if="mobilePromiseList.totalElements == 0"
            >
              <p>
                신청내역이 없습니다!<br />
                HOME 화면에서 나에게 맞는 상품을 찾아보세요!
              </p>
              <button @click="goLink('Mobile.Main')">
                HOME으로 가기
              </button>
            </div>
          </div>
        </div>
        <infinite-loading
          ref="infiniteLoading"
          :direction="direction"
          :identifier="infiniteId"
          @infinite="infiniteHandler"
        >
          <span slot="no-more"></span>
          <span slot="no-results"></span>
          <span slot="spinner"></span>
        </infinite-loading>
      </div>
    </div>
    <SortModal :show="isSortOpen" @close="sortModalClose" ref="sortModal" />
  </main>
</template>
<script>
import * as util from '@common/lib/common/utils.js';
import SortModal from '@/front/customer/views/internetApply/modal/SortModal';

import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';

import {
  mapActions as mobileMapActions,
  mapGetters as mobileMapGetters,
} from '@common/store/modules/mobile';
import * as mobileTypes from '@common/store/modules/mobile/types';

import {
  mapActions as chatMapActions,
  mapState as chatMapState,
  mapGetters as chatMapGetters,
} from '@common/store/modules/chat';
import * as chatActions from '@common/store/modules/chat/types';
import * as chatGetters from '@common/store/modules/chat/getters';

import InfiniteLoading from 'vue-infinite-loading';

import { sleep } from '@common/lib/common/utils';

export default {
  components: {
    SortModal,
    InfiniteLoading,
  },
  data() {
    return {
      isTab_1: true,
      isTab_2: false,
      isCompleted: false,
      direction: 'top',
      infiniteId: 0,
      list: [],
      size: 10,
      page: 1,
      isSortOpen: false,
      isSortText: '최신 순',
      isSortRealText: '',
      isSearchSort: 'CREATED_AT_DESC', // CREATED_AT_ASC , CREATED_AT_DESC

      visitPage: 0,
      scrollLocation: 0,
      isVisitName: [
        'Shops.Detail',
        'Mobile.Promise',
        'Apply.Main',
        'chat.room',
        'Shops.WriteReview',
        'Shops.Reviews',
      ], // 뒤로 이동시 가능한 방문 페이지 정리
    };
  },
  filters: {
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    nl2br(val) {
      return String(val)
        .split('\n')
        .join('<br />');
    },
  },
  // 페이지 이동시 호출됨, 여기서는 뒤로가기시 어디서 왔는지 체크
  async beforeRouteEnter(to, from, next) {
    return next(async vm => {
      await vm.fetch(from.name);
    });
  },
  async created() {
    // await this.searchMobilePromiseList();
    // this.list = this.mobilePromiseList;
    this.isCompleted = true;
  },
  async mounted() {
    // 페이징 뒤로가기 설정 시작
    this.page = 1;
    if (this.visitPage > 0) {
      for (var i = 0; i < this.visitPage - 1; i++) {
        this.infiniteId += 1;
      }
    } else {
      this.infiniteId += 1; //리스트 가져오기.
    }
    // 페이징 뒤로가기 설정 끝
  },
  computed: {
    ...mobileMapGetters({
      mobilePromiseList: mobileTypes.MOBILE_PROMISE_LIST,
    }),
    ...chatMapGetters({
      chatroom_with: chatGetters.CHATROOMS_WITH,
      chatroom: chatGetters.CHATROOM,
    }),
  },
  methods: {
    ...mobileMapActions([mobileTypes.SELECT_MOBILE_PROMISE_LIST]),
    ...chatMapActions([
      chatActions.FETCH_CHATROOM_WITH_STORE,
      chatActions.CHATROOMS_WITH_RESET_STATE,
      chatActions.CREATE_CHATROOM,
    ]),
    async fetch(fromName) {
      // 뒤로가기로 왔을때 저장된 값 확인
      if (this.isVisitName.includes(fromName)) {
        let visit_page = await localStorage.getItem(
          'visit_mobile_promise_list',
        );

        if (visit_page) {
          visit_page = JSON.parse(visit_page);
          this.visitPage = visit_page.page;
          this.scrollLocation = visit_page.scrollLocation;
          this.isSearchSort = visit_page.isSearchSort;

          if (this.isSearchSort == 'CREATED_AT_DESC') {
            this.isSortText = '최신 순';
          } else {
            this.isSortText = '오래된 순';
          }
        }
        // 데이터 담고 삭제
        await localStorage.removeItem('visit_mobile_promise_list');
      }
    },
    setVisitPage() {
      // 페이지 이동 전에 세션스토리지에 저장 (뒤로가기 처리하기 위함) - 시작
      const target = document.querySelector('#main_con');
      let scrollLocation = target.scrollTop; // 현재 스크롤바 위치

      const visit_page = {
        scrollLocation: scrollLocation,
        isSearchSort: this.isSearchSort,
        page: this.page,
      };

      localStorage.setItem(
        'visit_mobile_promise_list',
        JSON.stringify(visit_page),
      );
      // 페이지 이동 전에 세션스토리지에 저장 (뒤로가기 처리하기 위함) - 끝
    },
    getCreateAt(createAt) {
      return format(parseISO(createAt), 'yyyy-MM-dd');
    },
    async getListPageOne() {
      this.direction = 'top';
      this.page = 1;
      this.infiniteId += 1;
    },
    async infiniteHandler($state) {
      const target = document.querySelector('#main_con');
      if (this.infiniteId == 0) {
        $state.complete();
      } else {
        this.direction = 'bottom';
        await this.searchMobilePromiseList();

        if (this.page == 1) {
          this.list = [];
        }
        if (this.mobilePromiseList.content.length) {
          this.list.push(...this.mobilePromiseList.content);

          if (this.scrollLocation > 0) {
            setTimeout(() => {
              target.scrollTo(0, this.scrollLocation);
            }, 10);

            // 뒤로가기로 온 이후 페이지가 다 로딩이 되면 스크롤 저장 위치를 초기화
            setTimeout(() => {
              this.scrollLocation = 0;
            }, 1000);
          }

          this.page += 1;
          $state.loaded();
        } else {
          $state.complete();
        }
      }
    },
    async searchMobilePromiseList() {
      const params = {
        callPart: 'CUSTOMER',
        orderType: this.isSearchSort,
        page: this.page,
        size: this.size,
      };
      await this[mobileTypes.SELECT_MOBILE_PROMISE_LIST](params);
      console.log('mobilePromiseList');
      console.log(this.mobilePromiseList);
    },
    selectSort() {
      this.isSortOpen = true;
    },
    async sortModalClose(checked) {
      if (checked) {
        const target = document.querySelector('#main_con');
        this.isSortText = this.$refs.sortModal.selectSort;
        this.isSortRealText = this.$refs.sortModal.selectSortReal;
        this.isSearchSort = this.isSortRealText;

        await this.getListPageOne();
        target.scrollTo(0, 0);
      }

      this.isSortOpen = false;
    },
    goShopDetail(storeId) {
      this.setVisitPage();
      this.$router.push({
        name: 'Shops.Detail',
        params: {
          id: storeId,
        },
      });
    },
    goMobilePromise(id) {
      this.setVisitPage();
      const query = { promiseId: id, customer: true };
      this.$router.push({ name: 'Mobile.Promise', query: query });
    },
    async enterChatRoom(storeId) {
      this.setVisitPage();
      this[chatActions.CHATROOMS_WITH_RESET_STATE]();
      await this[chatActions.FETCH_CHATROOM_WITH_STORE]({
        chatRoomType: 'OneOnOne',
        storeId: storeId,
      });

      let name = 'chat.room';
      const params = {};
      if (this.chatroom_with.count == 0) {
        // name = 'chat.room.create';
        // params.storeId = storeId;
        this[chatActions.CREATE_CHATROOM]({
          chatRoomType: 'OneOnOne',
          memberId: '',
          storeId: storeId,
          estimateId: undefined,
        }).then(() => {
          console.log('this.chatroom');
          console.log(this.chatroom);
          params.uuid = this.chatroom.uuid;

          this.$router.push({
            name,
            params,
          });
        });
      } else {
        params.uuid = this.chatroom_with.content[0].uuid;
        this.$router.push({
          name,
          params,
        });
      }
    },
    storeAreaShort(area) {
      var areaShort = area.split(' ');
      return areaShort[2];
    },
    goToReview(item) {
      this.setVisitPage();
      this.$router.push({
        name: 'Shops.Reviews',
        params: { id: item.storeId },
        query: { type: 'mobile' },
      });
    },
    goToReviewWrite(item) {
      this.setVisitPage();
      this.$router.push({
        name: 'Shops.WriteReview',
        params: { id: item.storeId },
        query: { type: 'mobile' },
      });
    },
    goLink(link) {
      this.setVisitPage();
      this.$router.push({
        name: link,
      });
    },
    setShopProfileImg(shopName, shopId) {
      let path = util.setShopProfile(shopName, shopId, '100x100', '18');

      return path;
    },
  },
};
</script>
